import { api_GET, api_POST, api_PUT } from "./_api.js";

const integracao_api = {
    GetListIntregacoes: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Integracao/GetListIntregacoes/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListWorkflow: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Integracao/GetListWorkflow/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ExecuteIntegracoesAcoesPendentes: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Integracao/ExecuteIntegracoesAcoesPendentes`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    BuscarCodigoItem: (model = { integracao_Id: "", codigo: "" }) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Integracao/BuscarCodigoItem/${model.integracao_Id}/${model.codigo}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getMapa: (model = { integracao_Id: "", latitude: "", longitude: "", entidade: "", id_retorno: "" }) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Integracao/ExecuteIntegracaoFromLista/${model.integracao_Id}/${model.latitude}/${model.longitude}${model.entidade && model.id_retorno ? `/${model.entidade}/${model.id_retorno}` : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListIntegracoesSolicitacaoFiscalizacao: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Integracao/GetListIntegracoesSolicitacaoFiscalizacao`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetInfratorIntegracao: (cnpj) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Integracao/GetInfratorIntegracao/${cnpj}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default integracao_api;